import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import AppText from "../../components/Core/AppText/AppText";
import Button from "../../components/Core/Button/Button";
import AppInput from "../../components/Core/AppInput/AppInput";
import { FEEDBACK_MESSAGE_TYPE } from "../../configs/feedbackMessages";
import { useNavigate } from "react-router";
import { routes } from "../../configs/constants/routes";
import { getQueryStringValue } from "../../hooks/useQueryState";
import { toast } from "../../utils/toast";
import { useAuthStore } from "../../stores/auth.store";

type Inputs = {
	email: string;
};

const ForgotPassword: React.FC = () => {
	const authStore = useAuthStore();

	const { t } = useTranslation();

	const navigate = useNavigate();

	const orgIdFromQuery = getQueryStringValue("org");

	const { register, handleSubmit } = useForm<Inputs>();

	const onSubmit = handleSubmit(async (e) => {
		if (e.email) {
			const isSuccess = await authStore.forgotPassword(e.email, orgIdFromQuery);
			if (isSuccess) {
				toast.success(FEEDBACK_MESSAGE_TYPE.RESET_PASSWORD_LINK_SENT);
				navigate(routes.LOGIN);
			} else toast.error(FEEDBACK_MESSAGE_TYPE.SOMETHING_WENT_WRONG);
		}
	});

	return (
		<FormContainer>
			<AppText
				margin="2rem"
				letterSpacing="0.24rem"
				color="grayText"
				size="l"
				textTransform="uppercase"
			>
				{t("FORGOT_PASSWORD")}
			</AppText>
			<FormComponent onSubmit={onSubmit}>
				<AppInput {...register("email")} margin="0.5rem" placeholder="EMAIL" icon="email" />
				<Button margin="2rem">{t("SEND")}</Button>
			</FormComponent>
		</FormContainer>
	);
};

export default ForgotPassword;

const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: ${(props) => props.theme.colors.COLOR_DARK_GRAY};
	box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	width: 25.625rem;
	height: 25.3125rem;
	justify-content: center;
	margin-bottom: 5vh; /* to push login box up slightly above vertical center */
`;

const FormComponent = styled.form`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 16.875rem;
`;
